import { IImageConverted } from '@/types/interfaces';

function urlToFile(url, filename, mimeType) {
  return (fetch(url)
    .then((res) => res.arrayBuffer())
    .then((buf) => new File([buf], filename, { type: mimeType }))
  );
}

export async function bmpConvertor(source: File, destinationType = 'image/jpeg', quality = 0.9) {
  let w = 0;
  let h = 0;

  const initialImage = new Image();
  initialImage.src = URL.createObjectURL(source);
  initialImage.onload = () => {
    w = initialImage.width;
    h = initialImage.height;
    URL.revokeObjectURL(initialImage.src);
  };

  return createImageBitmap(source).then((imageBitmap) => {
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;

    const ctx = canvas.getContext('2d');
    ctx!.drawImage(imageBitmap, 0, 0, w, h, 0, 0, w, h);

    const url = canvas.toDataURL(destinationType, quality);
    const img = new Image();

    img.src = url;
    img.onload = () => {
      URL.revokeObjectURL(url);
    };

    return {
      url: img.src,
      type: destinationType,
      name: source.name.toLowerCase().replace('.bmp', '.jpeg'),
    } as IImageConverted;
  });
}

export async function bmpConvertorToFile(source: File) {
  const { url, name, type } = await bmpConvertor(source);
  return urlToFile(url, name, type).then((file) => file);
}

export async function convertBmpInFileList(fileList: FileList) {
  const newFileList: File[] = [];
  for (let i = 0; i < fileList.length; i += 1) {
    if (fileList[i].type.includes('bmp')) {
      // eslint-disable-next-line no-await-in-loop
      const convertedFile = await bmpConvertorToFile(fileList[i]);
      newFileList.push(convertedFile);
    } else {
      newFileList.push(fileList[i]);
    }
  }
  return newFileList;
}
